import React from 'react';
import {Field} from 'redux-form';

                                                                                      // import Snackbar from '@material-ui/core/Snackbar';

import {
  FormControl,
  FormHelperText,
  InputLabel,
  RadioGroup,
  Select,
  TextField,
} from '@material-ui/core';

import {
  Checkbox,
  RadioButtonGroup,
  SelectField,
                                                                                      // TextField,
  Toggle,
                                                                                      // DatePicker
} from 'redux-form-material-ui'

                                                                                      // import MenuItem from 'material-ui/MenuItem'
                                                                                      // import SelectField from 'material-ui/SelectField'

import SnackbarError from 'components/snackbar/snackbar-error';
import SnackbarSaveNotification from 'components/snackbar/snackbar-save-notification';

import SnackbarSample2 from 'components/snackbar/snackbar-error-sample-2';

export const renderLockedTextField = ({
  requiredText,
  label,
  emptyText,
  footerMessage,
  setValue,
  input,
  meta: { touched, invalid, error },
 ...custom
}) => (
<FormControl fullWidth error={touched }>
 <TextField
  required={false }
  disabled={true}
  label={label}
  placeholder={emptyText}
  helperText={footerMessage} // same as FormHelperText but not bold like FormHelperText
                                                                                      // error={touched && invalid}
  error={error ? true : false}
  hinttext={footerMessage}
  value={setValue}
  fullWidth
  variant='outlined'
  {...custom}
 />
 <FormHelperText>
 </FormHelperText>
</FormControl>
)


export const renderTextField = ({
  requiredText,
  locked,
  label,
  emptyText,
  footerMessage,
  input,
  meta: { touched, invalid, error },
 ...custom
}) => (
<FormControl fullWidth error={touched }>
 <TextField
  required={requiredText ? true : false }
  disabled={locked}
  label={label}
  placeholder={emptyText}
  helperText={footerMessage}
                                                                                      // error={touched && invalid}
  error={error ? true : false}
                                                                                      // hintText={footerMessage}
  hinttext={footerMessage}
  fullWidth
  variant='outlined'
  {...input}
  {...custom}
 />
 <FormHelperText>
                                                                                      {/* {footerMessage} */}
                                                                                      {/* {(touched && error) ? '<br />' + touched && error : ''} */}
                                                                                      {/* {(error) ? <> <br /> {error} </>: ''} */}
                                                                                      {/* {(error) ? <> <br /> {error} </>: ''} */}
  {(error) ? <span><b> <br /> {error} </b></span>: ''}
 </FormHelperText>
</FormControl>
)

export const renderTextField2 = ({
  requiredText,
  locked,
  label,
  emptyText,
  defaultValue,
  footerMessage,
  input,
  meta: { touched, invalid, error },
 ...custom
}) => (
<FormControl fullWidth error={touched }>
 <TextField
  required={requiredText ? true : false }
  disabled={locked}
  label={label}
  placeholder={emptyText}
  helperText={footerMessage}
  defaultValue={defaultValue}

                                                                                      // error={touched && invalid}
  error={error ? true : false}
                                                                                      // hintText={footerMessage}
  hinttext={footerMessage}

  fullWidth
  variant='outlined'
  {...input}
  {...custom}
 />
 <FormHelperText>
                                                                                      {/* {footerMessage} */}
                                                                                      {/* {(touched && error) ? '<br />' + touched && error : ''} */}
                                                                                      {/* {(error) ? <> <br /> {error} </>: ''} */}
                                                                                      {/* {(error) ? <> <br /> {error} </>: ''} */}
  {(error) ? <span><b> <br /> {error} </b></span>: ''}
 </FormHelperText>
</FormControl>
)

export const renderMultiLineTextField = ({
  requiredText,
  locked,
  label,
  emptyText,
  footerMessage,
  rows,
  input,
  meta: { touched, invalid, error },
 ...custom
}) => (
 <FormControl fullWidth error={touched }>
  <TextField
    required={requiredText ? true : false }
    disabled={locked}
    label={label}
    placeholder={emptyText}
                                                                                       // hintText={footerMessage}

    multiline
    rows={rows}
  
                                                                                       // error={touched && invalid}
    error={error ? true : false}
    helperText={touched && error}

   fullWidth
   variant="outlined"
   {...input}
   {...custom}
 />
 <FormHelperText>
  {footerMessage}
                                                                                      {/* {(touched && error) ? '<br />' + touched && error : ''} */}
  {(error) ? <span><b> <br /> {error} </b></span>: ''}
 </FormHelperText>
</FormControl>
)

export const renderDateTextField = ({
  requiredText,
  locked,
  label,
  emptyText,
  footerMessage,
  rows,
  input,
  meta: { touched, invalid, error },
 ...custom
}) => (
<FormControl fullWidth error={touched }>
 <TextField
   type="date"
                                                                                       //  defaultValue="2010-01-01"

  required={requiredText ? true : false }
  disabled={locked}
  label={label}
  placeholder={emptyText}
                                                                                       // hintText={footerMessage}

                                                                                       // error={touched && invalid}
  error={error ? true : false}
  helperText={touched && error}

  fullWidth
  variant='outlined'
  {...input}
  {...custom}
 />
 <FormHelperText>
  {footerMessage}
                                                                                      {/* {(touched && error) ? '<br />' + touched && error : ''} */}
  {(error) ? <span><b> <br /> {error} </b></span>: ''}
 </FormHelperText>
</FormControl>
)

export const renderDateTextField2 = ({
  requiredText,
  locked,
  label,
  emptyText,
  footerMessage,
  id,
  rows,
  input,
  meta: { touched, invalid, error },
 ...custom
}) => (
<FormControl fullWidth error={touched }>
                                                                                      {/* <InputLabel htmlFor={id}>{label}</InputLabel> */}
                                                                                      {/* <InputLabel htmlFor={id}>{label}</InputLabel> */}
  <span>{label}</span>
  <TextField
    type="date"
                                                                                       //  defaultValue="2010-01-01"

    required={requiredText ? true : false }
    disabled={locked}
                                                                                       // label={label}
                                                                                       // placeholder={emptyText}
                                                                                       // hintText={footerMessage}

                                                                                       // error={touched && invalid}
    error={error ? true : false}
    helperText={touched && error}

    fullWidth
    variant='outlined'
    {...input}
    {...custom}
  />
 <FormHelperText>
  {footerMessage}
                                                                                      {/* {(touched && error) ? '<br />' + touched && error : ''} */}
  {(error) ? <span><b> <br /> {error} </b></span>: ''}
 </FormHelperText>
</FormControl>
)





export const renderErrorText = ({
  input,
  meta: { touched, invalid, error },
 ...custom
}) => (
<FormControl fullWidth error={touched }>
                                                                                      {/* <FormHelperText> */}
                                                                                        {/* <h2> */}
    <h3>
                                                                                          {/* {(error) ? <span><b> <br /> {error} </b></span>: ''} */}
      {(error) ? <b> <br /> {error} <br/> <br/> <hr/> <br/> </b> : ''}
    </h3>
                                                                                        {/* </h2> */}
                                                                                      {/* </FormHelperText> */}
</FormControl>
)









export const renderCheckbox = ({
  objName,
  label,
  locked,
  footerMessage,
  meta: { touched, invalid, error },
  ...custom
}) => (
<FormControl fullWidth error={touched }>
                                                                                      {/* <span>{label}</span> */}
  <Field
    component={Checkbox}
    name={objName}
    label={label}
    disabled={locked ? true : false }
    {...custom}
  />
  <FormHelperText>
  {footerMessage}
                                                                                      {/* {(touched && error) ? '<br />' + touched && error : ''} */}
  {(error) ? <span><b> <br /> {error} </b></span>: ''}
 </FormHelperText>
</FormControl>
)


















export const renderToggleSwitch = ({
  objName,
  label,
  locked,
  footerMessage,
  meta: { touched, invalid, error },
  ...custom
}) => (
<FormControl fullWidth error={touched }>
  <Field
    component={Toggle}
    name={objName}
    label={label}
    disabled={locked ? true : false }
    {...custom}
  />
  <FormHelperText>
  {footerMessage}
                                                                                      {/* {(touched && error) ? '<br />' + touched && error : ''} */}
  {(error) ? <span><b> <br /> {error} </b></span>: ''}
 </FormHelperText>
</FormControl>
)




























export const renderRadioGroupField = ({
  footerMessage,
  id,
  input,
  label,
  locked,
  meta: { touched, error },
  children,
                                                                                       // ...rest,
  ...custom
}) => (
  <FormControl fullWidth error={touched }>
    <InputLabel htmlFor={id}>{label}</InputLabel>

    <RadioGroup
      {...input}
      {...custom}

      disabled={locked}

      native
                                                                                       //  displayEmpty          
                                                                                       // fullWidth

                                                                                       // checked={this.props.referralEntry.employedduringpasthistory.toString() === '0'}
    >
      {children}
    </RadioGroup>
                                                                                        {/* {renderFromHelper({ touched, error })} */}
                                                                                        {/* {renderFromHelper({ touched })} */}
    <FormHelperText>
      {footerMessage}
      {(error) ? <span><b> <br /> {error} </b></span>: ''}
    </FormHelperText>
  </FormControl>
)






export const renderRadioGroupField2 = ({
  objName,
  children,
  label,
  locked,
  footerMessage,
  meta: { touched, invalid, error },
  ...custom
}) => (
<FormControl fullWidth error={touched }>
  <span>{label}</span>
                                                                                      {/* <InputLabel shrink htmlFor={objName}>
                                                                                       {label}
                                                                                       </InputLabel> */}
  <Field
    component={RadioButtonGroup} 
    id={objName}
    name={objName}
    label={label}
    disabled={locked ? true : false }
    fullWidth
    {...custom}
  >
    {children}
  </Field>
  <FormHelperText>
  {footerMessage}
                                                                                      {/* {(touched && error) ? '<br />' + touched && error : ''} */}
  {(error) ? <span><b> <br /> {error} </b></span>: ''}
 </FormHelperText>
</FormControl>
)




























/*** children displayed as a child object */
export const renderSelectField = ({
  footerMessage,
  id,
  input,
  label,
  locked,
  meta: { touched, error },
  children,
 ...custom
}) => (
 <FormControl fullWidth error={touched }>
                                                                                      {/* <InputLabel htmlFor={id}>{label}</InputLabel> */}
  <span>{label}</span>
  <Select
     {...input}
     {...custom}

     disabled={locked}

     native
                                                                                       //  displayEmpty
     fullWidth
   >
     {children}
   </Select>
                                                                                       {/* {renderFromHelper({ touched, error })} */}
                                                                                       {/* {renderFromHelper({ touched })} */}
   <FormHelperText>
                                                                                        {/* {touched && error}
                                                                                       <br /> */}
    {footerMessage}
    {(error) ? <span><b> <br /> {error} </b></span>: ''}
  </FormHelperText>
</FormControl>
)



                                                                                                          // /*** has issues ...... ???? dont use */
                                                                                                          // /*** children passed in as parameter */
                                                                                                          // export const renderSelectField2 = ({
                                                                                                          //   children,
                                                                                                          //   footerMessage,
                                                                                                          //   id,
                                                                                                          //   input,
                                                                                                          //   label,
                                                                                                          //   locked,
                                                                                                          //   meta: { touched, error },
                                                                                                          //  ...custom
                                                                                                          // }) => (
                                                                                                          //  <FormControl fullWidth error={touched }>
                                                                                                          //   {/* <InputLabel htmlFor={id}>{label}</InputLabel> */}
                                                                                                          //   <span>{label}</span>
                                                                                                          //   <Select
                                                                                                          //     {...input}
                                                                                                          //     {...custom}
                                                                                                          //     // errorText={touched && error}
                                                                                                          //     disabled={locked}

                                                                                                          //     children={children}
                                                                                                          //     // floatingLabelText={label}

                                                                                                          //     onChange={(event, index, value) => input.onChange(value)}

                                                                                                          //      native
                                                                                                          //     //  displayEmpty          
                                                                                                          //      fullWidth
                                                                                                          //    />
                                                                                                          //    {/* {renderFromHelper({ touched, error })} */}
                                                                                                          //    {/* {renderFromHelper({ touched })} */}
                                                                                                          //    <FormHelperText>
                                                                                                          //     {touched && error}
                                                                                                          //     <br />
                                                                                                          //     {footerMessage}
                                                                                                          //     {(error) ? <span><b> <br /> {error} </b></span>: ''}
                                                                                                          //   </FormHelperText>
                                                                                                          // </FormControl>
                                                                                                          // )



/*** white background menu selection */
export const renderSelectField3 = ({
  objName,
  label,
  locked,
  footerMessage,
  meta: { touched, invalid, error },
  ...custom
}) => (
<FormControl fullWidth error={touched }>
  <span>{label}</span>
                                                                                                        {/* 
                                                                                                          <InputLabel shrink htmlFor={objName}>
                                                                                                            {label}
                                                                                                          </InputLabel> 
                                                                                                        */}
  <Field
    component={SelectField} 
    id={objName}
    name={objName}
    label={label}
    disabled={locked ? true : false }
    fullWidth
    {...custom}
  />
  <FormHelperText>
  {footerMessage}
                                                                                      {/* {(touched && error) ? '<br />' + touched && error : ''} */}
  {(error) ? <span><b> <br /> {error} </b></span>: ''}
 </FormHelperText>
</FormControl>
)



/*** children displayed as a child object */
export const renderSelectField4 = ({
  id,
  footerMessage,
  label,
  locked,
  children,
  input,
  meta: { touched, error, onChange },
                                                                                       //  ...custom
}) => (
 <FormControl fullWidth error={touched }>
                                                                                      {/* <InputLabel htmlFor={id}>{label}</InputLabel> */}
  <span>{label}</span>
                                                                                      {/* <select */}
  <Select
     {...input}
                                                                                       //  {...custom}
     disabled={locked}
     native
     fullWidth
                                                                                       //  displayEmpty          
  >
     {children}
   </Select>
                                                                                       {/* </select> */}
                                                                                       {/* {renderFromHelper({ touched, error })} */}
                                                                                       {/* {renderFromHelper({ touched })} */}
   <FormHelperText>
    {footerMessage}
    {(error) ? <span><b> <br /> {error} </b></span>: ''}
  </FormHelperText>
</FormControl>
)


/*** children displayed as a child object */
/*** tried to make defaultValue work but it doesnt */
export const renderSelectField5 = ({
  id,
  footerMessage,
  label,
  locked,
  defaultValue,
  children,
  input,
  meta: { touched, error, onChange },
                                                                                       //  ...custom
}) => (
 <FormControl fullWidth error={touched }>
                                                                                      {/* <InputLabel htmlFor={id}>{label}</InputLabel> */}
  <span>{label}</span>
                                                                                      {/* <select */}
  <Select
     {...input}
                                                                                       //  {...custom}
     disabled={locked}
     useDefault={true}
     defaultValue={defaultValue}
     native
     fullWidth
                                                                                       //  displayEmpty          
  >
     {children}
   </Select>
                                                                                       {/* </select> */}
                                                                                       {/* {renderFromHelper({ touched, error })} */}
                                                                                       {/* {renderFromHelper({ touched })} */}
   <FormHelperText>
    {footerMessage}
    {(error) ? <span><b> <br /> {error} </b></span>: ''}
  </FormHelperText>
</FormControl>
)


/*** children displayed as a child object */
/*** dataArray = [ { value: 1, label: 'label' }] */
export const renderSelectField6 = ({
  id,
  footerMessage,
  label,
  locked,
  dataArray,
  input,
  meta: { touched, error, onChange },
                                                                                       //  ...custom
}) => (
 <FormControl fullWidth error={touched }>
                                                                                      {/* <InputLabel htmlFor={id}>{label}</InputLabel> */}
  <span>{label}</span>
                                                                                      {/* <select */}
  <Select
     {...input}
                                                                                       //  {...custom}
     disabled={locked}
     native
     fullWidth
                                                                                       //  displayEmpty          
  >
      {dataArray.map((optionItem) => (
        <option key={optionItem.value} value={optionItem.value}>{optionItem.label}</option>
      ))}
   </Select>
                                                                                       {/* </select> */}
                                                                                       {/* {renderFromHelper({ touched, error })} */}
                                                                                       {/* {renderFromHelper({ touched })} */}
   <FormHelperText>
    {footerMessage}
    {(error) ? <span><b> <br /> {error} </b></span>: ''}
  </FormHelperText>
</FormControl>
)





                                                                                                                // /*** good for adds but doesnt work on edit???... */
                                                                                                                // /*** white background menu selection */
                                                                                                                // export const renderSelectField7 = ({
                                                                                                                //   objName,
                                                                                                                //   footerMessage,
                                                                                                                //   id,
                                                                                                                //   input,
                                                                                                                //   label,
                                                                                                                //   locked,
                                                                                                                //   meta: { touched, error, onChange },
                                                                                                                //   children,
                                                                                                                //   // ...custom
                                                                                                                // }) => (
                                                                                                                // <FormControl fullWidth error={touched }>
                                                                                                                //   <span>{label}</span>
                                                                                                                //   {/* <InputLabel shrink htmlFor={objName}>
                                                                                                                //     {label}
                                                                                                                //   </InputLabel> */}
                                                                                                                //   <Field
                                                                                                                //     component={SelectField} 
                                                                                                                //     id={objName}
                                                                                                                //     name={objName}
                                                                                                                //     label={label}
                                                                                                                //     disabled={locked ? true : false }
                                                                                                                //     fullWidth
                                                                                                                //     // {...custom}
                                                                                                                //   >
                                                                                                                //     {children}
                                                                                                                //   </Field>
                                                                                                                //   <FormHelperText>
                                                                                                                //   {footerMessage}
                                                                                                                //   {(touched && error) ? '<br />' + touched && error : ''}
                                                                                                                //  </FormHelperText>
                                                                                                                // </FormControl>
                                                                                                                // )







                                                                                                          // <FormHelperText>
                                                                                                          // {footerMessage}
                                                                                                          // {(touched && error) ? '<br />' + touched && error : ''}
                                                                                                          // </FormHelperText>
                                                                                                          // </FormControl>




                                                                                                          // export const renderFromHelper = ({ footerMessage, touched, error }) => {
                                                                                                          //   if (!(touched && error) && !(footerMessage)) {
                                                                                                          //     console.log('bbbbb-1');
                                                                                                          //     return 
                                                                                                          //   } else if ((touched && error)) {
                                                                                                          //     console.log('bbbbb-2');
                                                                                                          //     return <FormHelperText>
                                                                                                          //     {footerMessage}
                                                                                                          //     {(touched && error) ? '<br />' + touched && error : ''}
                                                                                                          //     </FormHelperText>
                                                                                                          //   } else if (footerMessage) {
                                                                                                          //     console.log('bbbbb-3');
                                                                                                          //     return <FormHelperText>{footerMessage}</FormHelperText>
                                                                                                          //   }
                                                                                                          // }





                                                                                                          // export const renderFromHelper = ({ footerMessage, touched, error }) => {
                                                                                                          //   if (!(touched && error)) {
                                                                                                          //     return
                                                                                                          //   } else if ((touched && error)) {
                                                                                                          //     return <FormHelperText>
                                                                                                          //       {footerMessage}
                                                                                                          //       {'<br />'}
                                                                                                          //       {touched && error}
                                                                                                          //     </FormHelperText>
                                                                                                          //   } else if (footerMessage) {
                                                                                                          //     return <FormHelperText>{footerMessage}</FormHelperText>
                                                                                                          //   }
                                                                                                          // }

                                                                                                          // // const validateFields = values => {
                                                                                                          // const validate = values => {
                                                                                                          //   const errors = {}

                                                                                                          //   if (!values.regid) {
                                                                                                          //     errors.regid = 'Required';
                                                                                                          //   } else if (!values.fname) {
                                                                                                          //     errors.fname = 'Required';
                                                                                                          //   } else if (!values.lname) {
                                                                                                          //     errors.lname = 'Required';
                                                                                                          //   } else if (!values.dob) {
                                                                                                          //     errors.dob = 'Required';
                                                                                                          //   } else if (!values.gender) {
                                                                                                          //     errors.gender = 'Required';
                                                                                                          //   } else if (!values.ethnicity) {
                                                                                                          //     errors.ethnicity = 'Required';
                                                                                                          //   }
                                                                                                          //   return errors
                                                                                                          // }













                                                                                                          // export const renderFromHelper = ({ footerMessage, touched, error }) => {
                                                                                                          //   if (!(touched && error)) {
                                                                                                          //     return
                                                                                                          //   } else {
                                                                                                          //     // return <FormHelperText>{touched && error}</FormHelperText>
                                                                                                          //     return <FormHelperText>
                                                                                                          //       {'<br />' + footerMessage && touched && error}
                                                                                                          //       {footerMessage}
                                                                                                          //     </FormHelperText>
                                                                                                          //   }
                                                                                                          // }



export const renderSnackbarError = ({
  input,
  meta: { touched, invalid, error },
 ...custom
}) => (
<FormControl fullWidth error={touched }>
  {(error) ?
    <SnackbarError
      variant="error"
      message = {error}
    />
  : ''}
</FormControl>
)



export const renderSnackbarSavedNotification = ({
  input,
  meta: { touched, invalid, savednotification },
 ...custom
}) => (
<FormControl fullWidth error={touched }>
  {(savednotification) ?
    <SnackbarSaveNotification
      variant="success"
      // variant="error"
      message = {savednotification}
    />
  : ''}
</FormControl>
)

                                                                                            // <FormControl fullWidth savednotification={touched }>
                                                                                            // <FormControl fullWidth error={touched }>

export const renderSnackbarSample2 = ({
  input,
  meta: { touched, invalid, sampleText2 },
 ...custom
}) => (
<FormControl fullWidth error={touched }>
  {(sampleText2) ?
    <SnackbarSample2
      variant="error"
      message = {sampleText2}
    />
  : ''}
</FormControl>
)
